var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    style: {
      enableBackground: "new 0 0 24 24"
    },
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;} \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0",
    id: "grid"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.226,24h16.548C18.45,24,19,23.45,19,22.774V17.5c0-0.276-0.224-0.5-0.5-0.5S18,17.224,18,17.5v5.274   C18,22.898,17.898,23,17.774,23H1.226C1.102,23,1,22.898,1,22.774V2.226C1,2.102,1.102,2,1.226,2h1.866C3.299,2.581,3.849,3,4.5,3   h10c0.651,0,1.201-0.419,1.408-1h1.866C17.898,2,18,2.102,18,2.226v3.839c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5V2.226   C19,1.55,18.45,1,17.774,1h-1.866c-0.207-0.581-0.757-1-1.408-1h-10C3.849,0,3.299,0.419,3.092,1H1.226C0.55,1,0,1.55,0,2.226   v20.549C0,23.45,0.55,24,1.226,24z M4.5,1h10C14.776,1,15,1.225,15,1.5S14.776,2,14.5,2h-10C4.224,2,4,1.775,4,1.5S4.224,1,4.5,1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,7.5C15,7.224,14.776,7,14.5,7h-10C4.224,7,4,7.224,4,7.5S4.224,8,4.5,8h10C14.776,8,15,7.776,15,7.5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.286,12.5c0-0.276-0.224-0.5-0.5-0.5H4.5C4.224,12,4,12.224,4,12.5S4.224,13,4.5,13h7.286   C12.063,13,12.286,12.776,12.286,12.5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,17C4.224,17,4,17.224,4,17.5S4.224,18,4.5,18h5c0.276,0,0.5-0.224,0.5-0.5S9.776,17,9.5,17H4.5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,17.5c0.044,0,0.089-0.006,0.133-0.018l2.318-0.639c0.083-0.023,0.16-0.067,0.221-0.129l7.334-7.335   c0.657-0.658,0.657-1.728,0-2.386c-0.637-0.637-1.749-0.637-2.386,0l-7.334,7.335c-0.061,0.062-0.105,0.137-0.128,0.221   l-0.639,2.317c-0.048,0.173,0.001,0.359,0.128,0.486C13.241,17.448,13.369,17.5,13.5,17.5z M14.586,14.942l7.241-7.241   c0.26-0.26,0.712-0.26,0.972,0c0.268,0.268,0.268,0.704,0,0.972l-7.241,7.241l-1.341,0.37L14.586,14.942z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.50839058e8c764874c39dffbcb173cde.svg";
export { ForwardRef as ReactComponent };